import React, { useState, useEffect } from 'react'
import { IoWarningOutline } from 'react-icons/io5'
import { AiOutlineClose } from 'react-icons/ai'
import api from '../utils/api'
import { ErrorNotification, SuccessNotification } from '../utils'
import useAuth from '../context/userContext'

const ImpersonationBanner = () => {
  const [elapsedTime, setElapsedTime] = useState(0)
  const [isVisible, setIsVisible] = useState(true)
  const [loading, setLoading] = useState(false)
  const { logout } = useAuth()


  const endImpersonation = async () => {
    setLoading(true)

    try {
      const response = await api.post('auth/impersonation/end-session/', {
        session_id: window.localStorage.getItem('session_id')
      })
      SuccessNotification("Impersonation ended successfully")
      window.localStorage.removeItem('is_impersonation')
      window.localStorage.removeItem('impersonation_start_time')
      window.location.reload()
      SuccessNotification("Impersonation ended successfully")
      logout()
    } catch (error) {
      ErrorNotification("Failed to end impersonation")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    // Check if impersonation is active
    const isImpersonation = window.localStorage.getItem('is_impersonation') === 'true'
    if (!isImpersonation) {
      return
    }

    // Get impersonation start time from localStorage
    let startTimeStr = window.localStorage.getItem('impersonation_start_time')

    // If start time doesn't exist, set it now (for cases where user refreshes)
    if (!startTimeStr) {
      const now = Date.now()
      window.localStorage.setItem('impersonation_start_time', now.toString())
      startTimeStr = now.toString()
    }

    const startTime = parseInt(startTimeStr, 10)
    const now = Date.now()
    const initialElapsed = Math.floor((now - startTime) / 1000) // in seconds
    setElapsedTime(Math.max(0, initialElapsed))

    // Update every second
    const interval = setInterval(() => {
      const currentTime = Date.now()
      const elapsed = Math.floor((currentTime - startTime) / 1000)
      setElapsedTime(Math.max(0, elapsed))
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  // Format time as HH:MM:SS
  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
  }

  // Check if impersonation is active
  const isImpersonation = window.localStorage.getItem('is_impersonation') === 'true'

  if (!isImpersonation || !isVisible) {
    return null
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[999] bg-[#000000] border-b-2 border-yellow-600 shadow-lg" style={{ height: '56px', zIndex: 999 }}>
      <div className="flex items-center justify-between px-4 py-3 md:px-10 h-full">
        <div className="flex items-center gap-3 flex-1">
          <IoWarningOutline className="hidden md:block text-yellow-900 dark:text-yellow-100 text-xl flex-shrink-0" />
          <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-3">
            <span className="text-yellow-900 dark:text-yellow-100 font-semibold text-sm md:text-base">
              Impersonation Mode Active
            </span>
            <div className="flex items-center gap-2">
              <span className="text-yellow-800 dark:text-yellow-200 text-xs md:text-sm font-medium">
                Session Duration:
              </span>
              <span className="text-yellow-900 dark:text-yellow-100 font-bold text-sm md:text-base font-mono bg-yellow-400 dark:bg-yellow-700 px-2 py-1 rounded">
                {formatTime(elapsedTime)}
              </span>
            </div>
          </div>
        </div>
        <button
          // onClick={exportToGeoJSON}
          onClick={endImpersonation}
          className="flex items-center gap-2 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md text-sm font-medium transition-colors"
          title="End Impersonation"
        >
          {loading ? "Please wait..." : "End Impersonation"}
        </button>
      </div>
    </div>
  )
}

export default ImpersonationBanner

